import { useMsal } from '@azure/msal-react'
import { toast } from 'react-hot-toast'

const useAuth = () => {
  const { instance } = useMsal()

  // Function to handle login
  const login = async () => {
    try {
      instance.loginRedirect({
        scopes: ['User.Read', 'Group.Read.All'],
      })
    } catch (error) {
      toast.error('Failed to authenticate')
    }
  }

  // Function to handle logout
  const logout = async (email: string) => {
    // Perform logout logic here
    await instance.logout({
      logoutHint: email,
      account: instance.getActiveAccount(),
      postLogoutRedirectUri: '/',
    })
  }

  return {
    login,
    logout,
  }
}

export default useAuth
